import React from 'react';
import { BreadcrumbsProps } from '@material-ui/core/Breadcrumbs';
import NavigateNextOutlined from '@material-ui/icons/NavigateNextOutlined';

const MuiBreadcrumbs: BreadcrumbsProps = {
    separator: <NavigateNextOutlined fontSize="small" />,
};

export default MuiBreadcrumbs;
